import React from "react"
import PropTypes from "prop-types"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import perksNearMe from "@irati/ui/images/perks-near-me.svg"
import {geolocationTracking} from "@irati-tracking/geolocation"
import appsConfig from "@irati-web/app/src/routeConfig"
import {Position} from "@irati/geolocation/src/types"
import {RouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Body, H3} from "@irati/ui/src/Typography"

import {FlexContainer, ImageWrapper, Image} from "./styled"

interface Context {
  apps: typeof appsConfig
}
interface Props {
  userLocation: Position,
  headerText?: string,
  bodyText?: string,
  id?: string,
  image?: string
}

const PerksNearMeCTA: React.FC<Props> = (props, {apps}: Context) => {
  const routerLinkUrl = "/perks/location"

  const {userLocation, headerText, bodyText, image, id} = props

  const handleButtonClick = () => {
    geolocationTracking.clickPerksHomepagePerksNearMeCTA(userLocation.city)
  }

  return (
    <FlexContainer id={id}>
      <ImageWrapper>
        <Image src={image || perksNearMe} />
        <div>
          <H3 paddingBottom={1}>{headerText}</H3>
          <Body small width="80%">
            {bodyText}
          </Body>
        </div>
      </ImageWrapper>
      <RouterLink cta to={routerLinkUrl} app={apps.SEARCH} onClick={handleButtonClick}>
        <Flex alignItems="center">
          <FormattedMessage id="perks.perksNearMeCTA.button.text" />
          <Icon icon={IconTypes.arrowRight} marginLeft />
        </Flex>
      </RouterLink>
    </FlexContainer>
  )
}

export default React.memo(injectIntl(PerksNearMeCTA))

PerksNearMeCTA.contextTypes = {
  apps: PropTypes.object.isRequired
}
